var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.5C4.79052 7.5 3.78164 6.64112 3.55001 5.5H1.5V4.5H3.55001C3.78164 3.35888 4.79052 2.5 6 2.5C7.20948 2.5 8.21836 3.35888 8.44999 4.5H21.5V5.5H8.44999C8.21836 6.64112 7.20948 7.5 6 7.5ZM7.5 5C7.5 5.82843 6.82843 6.5 6 6.5C5.17157 6.5 4.5 5.82843 4.5 5C4.5 4.17157 5.17157 3.5 6 3.5C6.82843 3.5 7.5 4.17157 7.5 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.5C14.7905 14.5 13.7816 13.6411 13.55 12.5H1.5V11.5H13.55C13.7816 10.3589 14.7905 9.5 16 9.5C17.2095 9.5 18.2184 10.3589 18.45 11.5H21.5V12.5H18.45C18.2184 13.6411 17.2095 14.5 16 14.5ZM17.5 12C17.5 12.8284 16.8284 13.5 16 13.5C15.1716 13.5 14.5 12.8284 14.5 12C14.5 11.1716 15.1716 10.5 16 10.5C16.8284 10.5 17.5 11.1716 17.5 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55001 19.5C7.78164 20.6411 8.79052 21.5 10 21.5C11.2095 21.5 12.2184 20.6411 12.45 19.5H21.5V18.5H12.45C12.2184 17.3589 11.2095 16.5 10 16.5C8.79052 16.5 7.78164 17.3589 7.55001 18.5H1.5V19.5H7.55001ZM10 20.5C10.8284 20.5 11.5 19.8284 11.5 19C11.5 18.1716 10.8284 17.5 10 17.5C9.17157 17.5 8.5 18.1716 8.5 19C8.5 19.8284 9.17157 20.5 10 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.fa8bacd7a41e062bf0a201a20221921b.svg";
export { ForwardRef as ReactComponent };